import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import AccountComponentsMiddleware from 'yoda-account-components/lib/middlewares/AccountComponentsMiddleware';
import AccountAnalyticsMiddleware from './AccountMiddleWare';

const rootMiddleware = [
    CommonMiddleware,
    AccountComponentsMiddleware,
    AccountAnalyticsMiddleware,
    MiniPDPAnalyticsMiddleware,
];

export default rootMiddleware;
